<template>
  <div>
    <el-dialog
        title="Liên kết tài khoản và tạo VA"
        :before-close="handleClose"
        :visible.sync="isOTPAuthenticationKienLongBankDialog"
        :show-close="true"
        :close-on-click-modal="false"
        width="600px"
        @open="handleOpen"
    >
      <el-form
          label-width="140px"
          :model="formData"
          label-position="left"
          :rules="rules"
          ref="formData"
      >
        <el-form-item label="Tên gợi nhớ" prop="label">
          <el-input v-model="formData.label" placeholder="Nhập tên gợi nhớ" style="width: 400px;" maxlength="100"  show-word-limit></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button
              style="width: 100%"
              type="primary"
              size="medium"
              :loading="loading.submit"
              @click="submitForm"
          >
            <i class="el-icon-circle-check"/>
            <span>Liên kết</span>
          </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "OTPAuthenticationAndVAToKienLongBankDialog",
  props: {
    isOTPAuthenticationKienLongBankDialog: {
      type: Boolean,
      default: () => false
    },
    bank: {
      type: Object,
      default: () => null
    },
  },

  data() {
    return {
      formData: {
        label: "",
        bank_account_id: "",
        company_id: ""
      },
      loading: {
        submit: false,
      },
    }
  },

  methods: {
    handleClose() {
      this.formData.label = "";
      this.formData.company_id = "";
      this.formData.bank_account_id = "";
      this.$emit("closeDialog");
    },
    handleCloseAll() {
      this.formData.label = "";
      this.formData.company_id = "";
      this.formData.bank_account_id = "";
      this.$emit("closeDialogAll");
    },
    handleOpen() {
      this.formData.bank_account_id = this.bank.idBankAccount
      this.formData.company_id = this.bank.idCompany
    },
    async submitForm() {
      sePayConnectionService.sendRequestCreateBankAccountVAKienLongBank(this.formData).then((resp) => {
        if (resp.data.data.code === "201") {
          NotifyMessage.leftCornerNotificationSuccess("Tạo mới thành công!")
          this.handleCloseAll()
        }else {
          NotifyMessage.leftCornerNotificationError("Tạo mới thất bại!")
          this.handleCloseAll()
        }
        this.loading.submit = false;
      }).catch((err) => {
        console.log(err);
      }).finally(
          this.loading.submit = false
      )
    },
  }
}
</script>

<style lang="scss" scoped>

</style>